// src/utils/roles.js
//
// Contrairement au projet université, il n'y a PAS de rôle ETUDIANT ici :
// seuls l'admin d'établissement, les enseignants et les parents se
// connectent à l'application (cf. Role dans models.py / views.py backend).

export const ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMINISTRATEUR: "ADMINISTRATEUR",
  ENSEIGNANT: "ENSEIGNANT",
  PARENT: "PARENT",
};
